import { render } from "./UploadDocumentFrontMobileView.vue?vue&type=template&id=77625712&scoped=true&ts=true"
import script from "./UploadDocumentFrontMobileView.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentFrontMobileView.vue?vue&type=script&lang=ts"

import "./UploadDocumentFrontMobileView.vue?vue&type=style&index=0&id=77625712&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77625712"]])

export default __exports__